import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeader() {
  const token = localStorage.getItem("gd_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const DAY_MAP = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };

// Returns { open: boolean, today: hoursEntry, nowLabel }
export function computeOpenStatus(hours) {
  if (!hours || !hours.length) return { open: false, today: null };
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Rome",
    hour12: false,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const wd = get("weekday");
  const idx = DAY_MAP[wd] ?? 0;
  const nowMin = parseInt(get("hour"), 10) * 60 + parseInt(get("minute"), 10);

  const today = hours[idx];
  const toMin = (s) => {
    const [h, m] = s.split(":").map((n) => parseInt(n, 10));
    return h * 60 + m;
  };

  let open = false;
  if (today && !today.closed) {
    const start = toMin(today.open);
    let end = toMin(today.close);
    if (end <= start) end += 1440; // overnight
    if (nowMin >= start && nowMin < end) open = true;
  }
  // yesterday overnight spill-over
  const yIdx = (idx + 6) % 7;
  const y = hours[yIdx];
  if (!open && y && !y.closed) {
    const start = toMin(y.open);
    const end = toMin(y.close);
    if (end <= start) {
      // closes after midnight
      if (nowMin < end) open = true;
    }
  }
  return { open, today };
}
